import { EAppActions, IAppAction, IAppState } from "./types";

export const appReducer = (prevState: IAppState, action: IAppAction): IAppState => {
  switch (action.type) {
    /* -------------------------------------------------------------------------------------------------
     * App
     * -----------------------------------------------------------------------------------------------*/
    case EAppActions.CONNECT_WALLET_OPEN:
      return {
        ...prevState,
        walletConnectOpen: action.payload.walletConnectOpen,
      };
    case EAppActions.SET_OFFCANVAS_OPEN:
      return {
        ...prevState,
        offCanvasOpen: action.payload.offCanvasOpen,
      };
    case EAppActions.SET_POOLS_SORT_BY:
      return {
        ...prevState,
        sortPoolsBy: action.payload.sortPoolsBy,
      };
    case EAppActions.SET_POOLS_SORTING_DIRECTION:
      return {
        ...prevState,
        sortPoolsSortingDirection: action.payload.sortPoolsSortingDirection,
      };
    case EAppActions.SET_CHOOSE_AVATAR_OPEN:
      return {
        ...prevState,
        chooseAvatarOpen: action.payload.chooseAvatarOpen,
      };
    case EAppActions.SET_WRONG_NETWORK_OPEN:
      return {
        ...prevState,
        wrongNetworkOpen: action.payload.wrongNetworkOpen,
      };
    case EAppActions.SET_SDK:
      return {
        ...prevState,
        sdk: action.payload.sdk,
      };
    case EAppActions.SET_CHOOSE_HANDLE_OPEN:
      return {
        ...prevState,
        chooseHandleOpen: action.payload.chooseHandleOpen,
      };
    case EAppActions.SET_ACTIVE_ZAP_POOL:
      return {
        ...prevState,
        activeZapPool: action.payload.activeZapPool,
      };
    case EAppActions.SET_LATEST_TX_HASH:
      return {
        ...prevState,
        latestTxHash: action.payload.latestTxHash,
      };
    default:
      throw new Error("No action was found!");
  }
};
